import { Icon } from 'ol/style';
import StyleFactory from '../../StyleFactory';
import defaultTheme from '../defaultTheme';
import legGeometry from '../geom/legGeometry';
let iconCache = {};

const getViapointIconByState = (isOpen, theme) => {
  const defaultViapointTheme = defaultTheme.LegsViapoints.viapoint;
  const viapointTheme = theme.viapoint || defaultViapointTheme;
  const iconSrc = isOpen ? viapointTheme.openSrc || defaultViapointTheme.openSrc : viapointTheme.closeSrc || defaultViapointTheme.openSrc;
  const key = iconSrc;

  if (key && iconCache[iconSrc]) {
    return iconCache[key];
  }

  const icon = new Icon({
    src: iconSrc
  });
  iconCache[key] = icon;
  return icon;
};

const legsThemeSelector = (value, theme) => ({
  color: theme.legs.color,
  width: theme.legs.width
});

const viapointStyle = StyleFactory.createStyle({
  image: (feature, resolution, params, viewOptions, theme) => {
    const isOpen = feature.get('IsOpen') === 'True';
    let icon = getViapointIconByState(isOpen, theme);
    return icon;
  }
});
const legsStyle = StyleFactory.createStyle({
  geometry: legGeometry({
    size: 400
  }),
  themeSelector: legsThemeSelector
});
export default ((...args) => (feature, resolution, params) => {
  const usage = feature.get('Usage');

  if (!usage) {
    return viapointStyle(...args)(feature, resolution, params);
  } else {
    return legsStyle(...args)(feature, resolution, params);
  }
});